"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorInfo = exports.catchTCOLError = void 0;
const catchTCOLError = ({ error }) => {
    let errorCode = '';
    let errorDetails = '';
    try {
        errorCode = error.codigoErrorNegocio;
        errorDetails = error.descripcionErrorNegocio;
    }
    catch (err) {
        // FAILED TO CATCH TCOL ERROR
    }
    return { errorCode, errorDetails };
};
exports.catchTCOLError = catchTCOLError;
const getErrorInfo = (error, log = false) => {
    let errorCode = '';
    let errorDetails = '';
    let errorResponse = null;
    if (error) {
        errorResponse = error.error;
        if (log) {
            console.log('-------------------------------------------------------------------');
            console.log('inicio', error);
        }
        // comrpobamos que sea un error js
        if (error instanceof Error && error.stack) {
            errorCode = 'Not defined';
            errorDetails = error.stack;
            if (error === null || error === void 0 ? void 0 : error.message) {
                if (log) {
                    console.log('if (error?.message)', JSON.stringify(error));
                    console.log('if (error?.message) str', error.message);
                }
                errorDetails = error.message;
            }
            else {
                errorDetails = JSON.stringify(error);
            }
            if (error === null || error === void 0 ? void 0 : error.status) {
                if (log) {
                    console.log('if (error?.status)', error === null || error === void 0 ? void 0 : error.status);
                }
                errorCode = error === null || error === void 0 ? void 0 : error.status;
            }
            else if (error === null || error === void 0 ? void 0 : error.message) {
                if (log) {
                    console.log('else if (error?.message)', error === null || error === void 0 ? void 0 : error.message);
                }
                const statusCodeExtracted = error === null || error === void 0 ? void 0 : error.message;
                if (log) {
                    console.log('statusCodeExtracted', error === null || error === void 0 ? void 0 : error.message);
                }
                let results = [];
                const myRegexString = /code [0-9]*/gm;
                const testRegExp = statusCodeExtracted.match(myRegexString);
                if (log) {
                    console.log('testRegExp', statusCodeExtracted.match(myRegexString));
                }
                if (testRegExp) {
                    results = [...statusCodeExtracted.match(myRegexString)];
                    if (log) {
                        console.log('testRegExp', [
                            ...statusCodeExtracted.match(myRegexString),
                        ]);
                    }
                }
                if (results.length > 0 &&
                    results[0] &&
                    results[0].split &&
                    results[0].split('code ')[1]) {
                    // eslint-disable-next-line prefer-destructuring
                    errorCode = results[0].split('code ')[1];
                    if (log) {
                        console.log('errorCode', results[0].split('code ')[1]);
                    }
                }
            }
        }
        else {
            // intentamos extraer de backend de tcol
            ({ errorCode, errorDetails } = (0, exports.catchTCOLError)(error));
            // resto de casos si aun no hemos conseguido nada
            if (!errorCode && !errorDetails && error) {
                const errorFull = !error.response
                    ? JSON.stringify(error)
                    : error.response;
                errorCode = error.status || '500';
                errorDetails = errorFull || 'Error en el servidor no tipado';
            }
        }
    }
    else {
        errorCode = '500';
        errorDetails = 'Error error nulo';
    }
    if (log) {
        console.log('errorCode', errorCode, 'errorDetails', errorDetails);
        console.log('-------------------------------------------------------------------');
    }
    return { errorCode, errorDetails, error: errorResponse };
};
exports.getErrorInfo = getErrorInfo;
//# sourceMappingURL=tools.js.map